var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.456,72.67l-9.908,21.081c-1.166,2.48-4.121,3.546-6.601,2.38c-2.424-1.139-3.493-3.997-2.452-6.44l9.158-21.419  c1.167-2.728,4.324-3.994,7.053-2.827c2.728,1.166,3.994,4.324,2.827,7.052C39.512,72.548,39.479,72.619,39.456,72.67z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.41,17.534c-1.325-0.982-3.154-0.66-4.062,0.718l-3.175,4.809c-0.909,1.377-1.598,3.854-1.53,5.502l0.985,24.281  c0.067,1.648,1.472,3.008,3.122,3.021l0.897,0.008c1.65,0.014,3.371-1.274,3.824-2.861l7.527-26.358  c0.453-1.587-0.261-3.688-1.586-4.671L30.41,17.534z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.213,21.844c4.929,0.279,9.201-3.743,9.335-8.795c0.134-5.061-3.848-9.301-8.798-9.354   c-4.917-0.057-9.109,4.157-9.087,9.131C43.684,17.573,47.482,21.574,52.213,21.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.258,43.087L49.553,25.238c-0.178-0.108-0.392-0.227-0.586-0.318c-2.814-1.32-6.161-0.129-7.517,2.66   c-0.671,0.79-1.185,1.733-1.462,2.804L34.2,52.709c-0.243,0.936-0.285,1.877-0.156,2.777c-0.349,2.149,0.438,4.419,2.262,5.873   l15.983,12.741v17.62c0,2.739,2.222,4.961,4.961,4.961s4.961-2.222,4.961-4.961v-20c-0.004-1.26-0.487-2.532-1.449-3.492   l-0.209-0.209L48.096,55.586l4.282-16.519l20.724,9.724l-2.724,45.553c-0.07,1.172,0.823,2.179,1.995,2.249   c0.043,0.003,0.086,0.004,0.129,0.004c1.116,0,2.053-0.87,2.12-1.999l2.68-44.826c0.858-0.24,1.634-0.785,2.142-1.602   C80.52,46.438,79.989,44.163,78.258,43.087z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHike);
export default __webpack_public_path__ + "static/media/HIKE.b178013667ab8bc6eb26b91f5b2ebff0.svg";
export { ForwardRef as ReactComponent };